export default "__VITE_ASSET__Clk7q1nz__"